"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.step.brief': 'Brief',
    'socialMediaPlan.step.preview': 'Podgląd AI',
    'socialMediaPlan.step.schedule': 'Planowanie',
};
